import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Blog.css";
import { blogPosts } from "./blogData";
import hiveText from "../../assets/logos/hivecutext.webp";
import siteBg from "../../assets/backgrounds/site_bg.png";

const BLOG_TITLE =
  "Blog HiveTeam | SEO, AEO si Web Development pentru Design Interior";
const BLOG_DESCRIPTION =
  "Articole practice in romana despre SEO, AEO, web development, branding si crestere online pentru firme de design interior, amenajari interioare si arhitectura.";

const BlogPage = () => {
  const [query, setQuery] = useState("");

  const filteredPosts = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) {
      return blogPosts;
    }
    return blogPosts.filter((post) => {
      return (
        post.title.toLowerCase().includes(q) ||
        post.description.toLowerCase().includes(q) ||
        post.category.toLowerCase().includes(q) ||
        post.keywords.some((k) => k.toLowerCase().includes(q))
      );
    });
  }, [query]);

  const canonicalUrl = "https://hiveteam.dev/blog";

  const blogSchema = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "HiveTeam Blog",
    url: canonicalUrl,
    description: BLOG_DESCRIPTION,
    inLanguage: "ro-RO",
    publisher: {
      "@type": "Organization",
      name: "HiveTeam",
      url: "https://hiveteam.dev",
    },
  };

  return (
    <div className="blog-page" style={{ "--blog-bg-image": `url(${siteBg})` }}>
      <Helmet>
        <title>{BLOG_TITLE}</title>
        <meta name="description" content={BLOG_DESCRIPTION} />
        <meta
          name="keywords"
          content="blog seo romania, aeo romania, design interior seo, amenajari interioare marketing, creare site-uri, hiveteam blog"
        />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={BLOG_TITLE} />
        <meta property="og:description" content={BLOG_DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:site_name" content="HiveTeam" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={BLOG_TITLE} />
        <meta name="twitter:description" content={BLOG_DESCRIPTION} />
        <script type="application/ld+json">{JSON.stringify(blogSchema)}</script>
      </Helmet>

      <header className="blog-topbar">
        <Link to="/" className="blog-logo-link" aria-label="HiveTeam Homepage">
          <img src={hiveText} alt="HiveTeam" className="blog-logo" />
        </Link>
        <nav className="blog-top-actions" aria-label="Actiuni rapide">
          <Link to="/" className="blog-btn blog-btn-secondary">
            Site principal
          </Link>
          <Link to="/#service" className="blog-btn blog-btn-ghost">
            Servicii
          </Link>
          <Link to="/#contact" className="blog-btn blog-btn-primary">
            Cere oferta
          </Link>
        </nav>
      </header>

      <section className="blog-hero">
        <p className="blog-kicker">HiveTeam Blog</p>
        <h1>SEO si AEO pentru business-uri de design interior din Romania</h1>
        <p>
          50 de articole practice despre web development, branding, SEO si AI
          search pentru firme care vor sa creasca organic.
        </p>
        <div className="blog-hero-cta">
          <Link to="/#contact" className="blog-btn blog-btn-primary">
            Discutam proiectul tau
          </Link>
          <Link to="/#hivePort" className="blog-btn blog-btn-secondary">
            Vezi portofoliu
          </Link>
        </div>
      </section>

      <section className="blog-filter">
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          type="text"
          placeholder="Cauta articol (ex: amenajari interioare, arhitect, AEO)"
          aria-label="Cauta articol"
        />
      </section>

      <section className="blog-grid" aria-label="Lista articole blog">
        {filteredPosts.map((post) => (
          <article key={post.id} className="blog-card">
            <p className="blog-card-category">{post.category}</p>
            <h2>
              <Link to={`/blog/${post.slug}`}>{post.title}</Link>
            </h2>
            <p>{post.description}</p>
            <div className="blog-card-meta">
              <span>{post.publishedAt}</span>
              <span>{post.readTime}</span>
            </div>
            <div className="blog-tags">
              {post.keywords.slice(0, 3).map((tag) => (
                <span key={`${post.slug}-${tag}`} className="blog-tag">
                  {tag}
                </span>
              ))}
            </div>
            <Link className="blog-read-more" to={`/blog/${post.slug}`}>
              Citeste articolul
            </Link>
          </article>
        ))}
      </section>

      <section className="blog-bottom-cta">
        <h2>Vrei rezultate reale, nu doar trafic?</h2>
        <p>
          HiveTeam construieste site-uri orientate pe conversie pentru creare
          site-uri, design interior, amenajari interioare si branduri care vor
          crestere pe termen lung.
        </p>
        <div className="blog-hero-cta">
          <Link to="/#contact" className="blog-btn blog-btn-primary">
            Trimite brief acum
          </Link>
          <Link to="/" className="blog-btn blog-btn-secondary">
            Inapoi la homepage
          </Link>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
